// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb-swm {
  margin-top: 1rem;
  margin-left: 2%; }

.mexico-sw-map-container {
  height: 40%;
  margin-top: 0.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center; }
  .mexico-sw-map-container .mexico-sw-map {
    box-shadow: rgba(255, 255, 255, 0.05) 2px 2px 6px;
    width: 90vw;
    height: 20rem;
    position: relative; }
    .mexico-sw-map-container .mexico-sw-map .basin-id {
      position: absolute;
      z-index: 10;
      color: white;
      margin: 1rem;
      font-weight: bold; }
    .mexico-sw-map-container .mexico-sw-map .center-basin {
      position: absolute;
      z-index: 10;
      bottom: 10%;
      right: 1%;
      background-color: #008080c4;
      border-radius: 4px;
      color: white;
      border: 2px solid white;
      padding: 0.5rem; }
      .mexico-sw-map-container .mexico-sw-map .center-basin:hover {
        background-color: teal; }
    .mexico-sw-map-container .mexico-sw-map canvas {
      height: 100%; }

.mxsw-report-container {
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center; }
  .mxsw-report-container .report-select {
    width: 90vw;
    margin-top: 1rem;
    background-color: #002044;
    color: #fff;
    height: 75px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem; }
    .mxsw-report-container .report-select .report-item {
      padding: 8px;
      border-radius: 4px; }
      .mxsw-report-container .report-select .report-item:hover {
        background-color: #fff;
        color: #002044;
        cursor: pointer; }
    .mxsw-report-container .report-select .active {
      font-weight: bold;
      background-color: #fff;
      color: #002044; }
  .mxsw-report-container .mxsw-report-data-container {
    margin-top: 1rem;
    display: flex;
    justify-content: space-evenly;
    width: 98%; }
    .mxsw-report-container .mxsw-report-data-container .station-info,
    .mxsw-report-container .mxsw-report-data-container .water-data {
      background-color: #002044;
      width: 48%;
      border-radius: 4px;
      box-shadow: rgba(255, 255, 255, 0.05) 2px 2px 6px;
      padding: 1rem; }
      .mxsw-report-container .mxsw-report-data-container .station-info h3,
      .mxsw-report-container .mxsw-report-data-container .water-data h3 {
        text-align: center;
        color: white; }
      .mxsw-report-container .mxsw-report-data-container .station-info .mx-data-list,
      .mxsw-report-container .mxsw-report-data-container .water-data .mx-data-list {
        list-style: none;
        color: white; }
    .mxsw-report-container .mxsw-report-data-container .station-info {
      width: 98%; }
    .mxsw-report-container .mxsw-report-data-container .station-container {
      display: flex;
      justify-content: space-evenly;
      color: white;
      margin-top: 2rem; }
  .mxsw-report-container .list-container {
    position: static;
    width: 100%;
    overflow: scroll;
    height: 20vh;
    overflow-x: hidden !important; }
  .mxsw-report-container ::-webkit-scrollbar {
    width: 10px; }
  .mxsw-report-container ::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey; }

.report-table-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem; }
  .report-table-container .table-wrapper {
    width: 90vw;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: scroll;
    padding-left: 12%; }
  .report-table-container table {
    color: white; }
  .report-table-container thead tr {
    background-color: #002044; }
  .report-table-container thead, .report-table-container tbody {
    font-size: 12px; }
  .report-table-container tbody tr {
    background-color: #18244c; }
  .report-table-container th {
    position: unset !important; }
  .report-table-container .table-container .table-container--scrollable {
    margin-left: 10%; }

.site-info-accordion {
  width: 50%; }
  .site-info-accordion .accordion-button {
    background-color: #002044; }
`, "",{"version":3,"sources":["webpack://./src/features/reports/MexicoReport/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EANrB;IAQI,iDAAiD;IACjD,WAAW;IACX,aAAa;IACb,kBAAkB,EAAA;IAXtB;MAaM,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,iBAAiB,EAAA;IAjBvB;MAoBM,kBAAkB;MAClB,WAAW;MACX,WAAW;MACX,SAAS;MACT,2BAA2B;MAC3B,kBAAkB;MAClB,YAAY;MACZ,uBAAuB;MACvB,eAAe,EAAA;MA5BrB;QA6BgB,sBAAsB,EAAA;IA7BtC;MAgCM,YAAY,EAAA;;AAKlB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;EALrB;IAOI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa,EAAA;IAhBjB;MAkBM,YAAY;MACZ,kBAAkB,EAAA;MAnBxB;QAqBQ,sBAAsB;QACtB,cAAc;QACd,eAAe,EAAA;IAvBvB;MA2BM,iBAAiB;MACjB,sBAAsB;MACtB,cAAc,EAAA;EA7BpB;IAiCI,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,UAAU,EAAA;IApCd;;MA2CM,yBAAyB;MACzB,UAAU;MACV,kBAAkB;MAClB,iDAAiD;MACjD,aAAa,EAAA;MA/CnB;;QAwCQ,kBAAkB;QAClB,YAAY,EAAA;MAzCpB;;QAiDQ,gBAAgB;QAChB,YAAY,EAAA;IAlDpB;MAqDoB,UAAW,EAAA;IArD/B;MAuDM,aAAa;MACb,6BAA6B;MAC7B,YAAY;MACZ,gBAAgB,EAAA;EA1DtB;IA8DI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,6BAA6B,EAAA;EAlEjC;IAqEI,WAAW,EAAA;EArEf;IAwEI,0BAA0B;IAC1B,4BAA4B,EAAA;;AAIhC;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAA;EALlB;IAQI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB,EAAA;EAbrB;IAiBI,YAAY,EAAA;EAjBhB;IAsBM,yBAAyB,EAAA;EAtB/B;IA2BI,eAAe,EAAA;EA3BnB;IAgCM,yBAAyB,EAAA;EAhC/B;IAqCI,0BAA0B,EAAA;EArC9B;IAwCI,gBAAgB,EAAA;;AAMpB;EACE,UAAU,EAAA;EADZ;IAII,yBAAyB,EAAA","sourcesContent":[".breadcrumb-swm {\n  margin-top: 1rem;\n  margin-left: 2%;\n}\n\n.mexico-sw-map-container {\n  height: 40%;\n  margin-top: 0.5rem;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .mexico-sw-map {\n    box-shadow: rgba(255, 255, 255, 0.05) 2px 2px 6px;\n    width: 90vw;\n    height: 20rem;\n    position: relative;\n    .basin-id {\n      position: absolute;\n      z-index: 10;\n      color: white;\n      margin: 1rem;\n      font-weight: bold;\n    }\n    .center-basin {\n      position: absolute;\n      z-index: 10;\n      bottom: 10%;\n      right: 1%;\n      background-color: #008080c4;\n      border-radius: 4px;\n      color: white;\n      border: 2px solid white;\n      padding: 0.5rem;\n      &:hover { background-color: teal;}\n    }\n    canvas {\n      height: 100%;\n    }\n  }\n}\n\n.mxsw-report-container {\n  width: 100%;\n  height: 50vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  .report-select {\n    width: 90vw;\n    margin-top: 1rem;\n    background-color: #002044;\n    color: #fff;\n    height: 75px;\n    border-radius: 4px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    .report-item {\n      padding: 8px;\n      border-radius: 4px;\n      &:hover {\n        background-color: #fff;\n        color: #002044;\n        cursor: pointer;\n      }\n    }\n    .active {\n      font-weight: bold;\n      background-color: #fff;\n      color: #002044;\n    }\n  }\n  .mxsw-report-data-container {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: space-evenly;\n    width: 98%;\n    .station-info,\n    .water-data {\n      h3 {\n        text-align: center;\n        color: white;\n      }\n      background-color: #002044;\n      width: 48%;\n      border-radius: 4px;\n      box-shadow: rgba(255, 255, 255, 0.05) 2px 2px 6px;\n      padding: 1rem;\n      .mx-data-list {\n        list-style: none;\n        color: white;\n      }\n    }\n    .station-info { width: 98% }\n    .station-container { \n      display: flex;\n      justify-content: space-evenly;\n      color: white;\n      margin-top: 2rem;\n    }\n  }\n  .list-container {\n    position: static;\n    width: 100%;\n    overflow: scroll;\n    height: 20vh;\n    overflow-x: hidden !important;\n  }\n  ::-webkit-scrollbar {\n    width: 10px;\n  }\n  ::-webkit-scrollbar-thumb {\n    background-color: darkgrey;\n    outline: 1px solid slategrey;\n  }\n}\n\n.report-table-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n\n  .table-wrapper {\n    width: 90vw;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: scroll;\n    padding-left: 12%;\n  }\n\n  table {\n    color: white;\n  }\n\n  thead { \n    tr {\n      background-color: #002044;\n    }\n   }\n\n  thead, tbody {\n    font-size: 12px;\n  }\n\n  tbody {\n    tr {\n      background-color: #18244c;\n    }\n  }\n\n  th {\n    position: unset !important; \n  }\n  .table-container .table-container--scrollable {\n    margin-left: 10%;\n  }\n\n}\n\n\n.site-info-accordion {\n  width: 50%;\n  \n  .accordion-button {\n    background-color: #002044;   \n  }\n}\n\n// #18244c"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
